import { useState } from 'react';
import StartingState from './starting-state';
import { useGetUser, useGetUserStats } from '../../hooks/api-hooks';
import ViewCurrentNeofaceSelection from '../../partials/view-persona';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowsRightLeftIcon, EyeIcon, PencilIcon, SparklesIcon, UserCircleIcon } from '@heroicons/react/24/outline';
import FacePresence from './stats';

export default function Dashboard() {
  const user = useGetUser();
  const userStats = useGetUserStats();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate()

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <div>
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-2xl md:text-3xl text-slate-800 dark:text-slate-100 font-bold">Dashboard</h1>
        </div>
      </div>

      {/* My Neoface section */}
      <div className="mt-8">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold text-slate-800">My Neoface</h2>
          {user.data?.persona?.id && (
            <Link
              to="/create-neoface?redo=true"
              className="text-sm text-indigo-600 hover:text-indigo-500 font-medium flex items-center gap-1"
            >
              <PencilIcon className="h-4 w-4" />
              Change Neoface
            </Link>
          )}
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-slate-200">
          {user.data?.persona?.id ? (
            <div className="p-6">
              <div className="flex items-start gap-6">
                <div className="relative group">
                  <div className="relative">
                    <div
                      onClick={openModal}
                      className="w-24 h-24 rounded-full overflow-hidden ring-2 ring-slate-100 cursor-pointer">
                      <img
                        src={user.data?.persona?.url || ''}
                        alt="Your Neoface"
                        className="w-full h-full object-cover transform transition group-hover:scale-105"
                      />
                    </div>
                    <SparklesIcon className="absolute -top-1 -right-1 h-5 w-5 text-indigo-500" />
                  </div>

                  <button
                    onClick={openModal}
                    className="mt-2 w-full flex items-center justify-center gap-1.5 px-3 py-1.5 text-sm text-slate-600 hover:text-slate-900 bg-slate-50 hover:bg-slate-100 rounded-md transition-colors"
                  >
                    <EyeIcon className="h-4 w-4" />
                    View Full
                  </button>
                </div>

                <div className="flex-1">
                  <div className="flex sm:flex-row flex-col items-start sm:items-center gap-2 mb-1">
                    <h3 className="text-lg font-medium text-slate-900">Your Primary Neoface</h3>
                    <span
                      className="inline-flex items-center rounded-full bg-green-50 px-2 py-0.5 text-xs font-medium text-green-700">
                      Ready to use
                    </span>
                  </div>
                  <p className="text-sm text-slate-500">
                    This is your neoface that will be used to anonymize your content.
                  </p>
                  <div className="mt-3 items-center gap-2 text-sm text-slate-500 sm:flex hidden">
                    <span className="inline-block w-2 h-2 rounded-full bg-green-500" />
                    Active and ready for content creation
                  </div>

                  {/* New button for navigating to anonymize page */}
                  <button
                    onClick={() => navigate('/anonymize-content')}
                    className="mt-4 w-full sm:w-auto flex items-center justify-center gap-1.5 px-3 py-1.5 text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 rounded-md transition-colors"
                  >
                    <ArrowsRightLeftIcon className="h-4 w-4" />
                    Anonymize Your Content
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="p-8 text-center">
              <div className="mx-auto w-16 h-16 rounded-full bg-slate-50 flex items-center justify-center mb-4">
                <UserCircleIcon className="h-8 w-8 text-slate-400" />
              </div>
              <h3 className="text-lg font-medium text-slate-900 mb-2">
                Choose Your New Identity
              </h3>
              <p className="text-sm text-slate-500 mb-4 max-w-sm mx-auto">
                Before you can anonymize your content, you need to create your Neoface. This will be used to anonymize your content on the anonymize content page.
              </p>
              <Link
                to="/create-neoface"
                className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Create Neoface
              </Link>
            </div>
          )}
        </div>
      </div>

      {/* Neoface Modal */}
      <ViewCurrentNeofaceSelection isOpen={isModalOpen} onClose={closeModal} imageUrl={user.data?.persona?.url || ''} />

      <div className="mt-8 presence">
        <FacePresence swapCount={userStats.data ? userStats.data[0].value : 0} />
      </div>

      <div className="mt-8">
        <StartingState />
      </div>
    </div>
  );
}